<template>
  <div id="content">
    <section>
      <form>
        <div class="inner">
          <p class="paging">
            <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
          </p>
          <h1 v-if="entity.name">{{ entity.name }}</h1>
        </div>
        <tabs-wrapper>
        <tabs-content>
        <locality-detail-form
            :entity="entity"
            :operatorOptions="operatorOptions"
            :isEditable="true"
            ref="localitydetailformref"
        ></locality-detail-form>
        <section class="buttons">
          <p>
            <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
            </router-link>
            <input type="submit" :value="'Uložit' | translate"
                   :class="['btn']"
                   @click.prevent.stop="createEntity()">
          </p>
        </section>
        </tabs-content>
        </tabs-wrapper>
      </form>
    </section>
  </div>
</template>

<script>
import LocalityDetailForm from "@/components/views/localities/locality/LocalityDetailForm";
import detailActions from "@/components/mixins/detail-actions";
import localities from "./mixins/localities";
import TabsWrapper from "@/components/common/tabs/TabsWrapper";
import TabsList from "@/components/common/tabs/TabsList";
import TabsListItem from "@/components/common/tabs/TabsListItem";
import TabsContent from "@/components/common/tabs/TabsContent";
import selectOperatorBusinessModel from "@/components/mixins/select-operator-business-model";


export default {
  name: "LocalitiesDetail",
  components: {
    LocalityDetailForm,
    TabsContent,
    TabsListItem,
    TabsList,
    TabsWrapper
  },
  mixins: [detailActions, localities, selectOperatorBusinessModel],
  created(LocalityService, OperatorService) {
    this.entityService = LocalityService;
    this.operatorService = OperatorService;
    this.getOperators(true, true);
    this.entity.id_operator = this.$_loggedUser_operatorId;
  },
  data(){
    return {
      entity: {
        name: '',
        description: '',
        id_operator:null,
        maintenance: false,
      }
    }
  },
  methods:{
    createEntity(redirect = false) {
      this.entityService.createEntity(this.filterFormParams({...this.entity}))
          .then(data => {
            if (redirect === true) {
              this.$router.push({name: this.moduleName})
            } else {
              this.$router.push({name: this.detailPageRouteName, params: {id: data.id}})
            }
            this.setSuccessMessage();
          })
          .catch(function (error) {
            this.setErrorMessage(this.processErrorMessage(error))
          }.bind(this))
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/views/localities/LocalitiesNew.vue